import React from "react";
import { useObservable } from "micro-observables";
import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import { getStartedManager } from "@core/service-container";
import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import WeightIcon from "@assets/icons/weight.svg";
import { RoutesPath } from "@ui/navigation/routes";
import { OnboardingCard } from "@ui/pages/get-started/components/onboarding-card";
import { ArrowButton } from "@ui/pages/get-started/components/arrow-button";

interface ExercisesCardProps {
	className?: string;
}

export const ExercisesCard: React.FC<ExercisesCardProps> = ({ className }) => {
	const { format } = useI18n();
	const navigate = useNavigate();
	const exercisesStepStatus = useObservable(getStartedManager.exercisesStepStatus);

	return (
		<OnboardingCard
			className={className}
			status={exercisesStepStatus}
			icon={WeightIcon}
			mainHeadline={format("getStarted.exercisesCard.mainHeadline")}
			secondaryHeadline={format("getStarted.exercisesCard.secondaryHeadline")}
			description={format("getStarted.exercisesCard.description")}
			bottom={
				<ArrowButton
					label={format("getStarted.exercisesCard.ctaButton")}
					onClick={() => {
						analyticsService.trackEvent({
							category: AnalyticsCategory.GETSTARTED,
							action: "cardCTA",
							params: ["exercises"],
						});
						navigate(RoutesPath.ExerciseList);
					}}
				/>
			}
		/>
	);
};
